import JobApplicationBoarding from './JobApplicationBoarding.component';

export default JobApplicationBoarding;